import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {IGetStorePublishProductListInterface, IProductDetails} from '@app/feature/store-editor/components/layout/IlistProducts.interface';
import {InksoftService} from '@app/shared/services/inksoft/inksoft.service';
import {environment} from '@env/environment';
import {IProduct, SelectProductInput} from '@app/feature/store-editor/components/layout/store-editor.interface';
import { CommonService } from '@app/shared/services/common/common.service';

@Component({
  selector: 'app-select-products',
  templateUrl: './select-products.component.html',
  styleUrls: ['./select-products.component.css']
})
export class SelectProductsComponent implements OnInit {
  imgBaseUrl = environment.imgBaseURL;
  listProducts: IProductDetails[] = [];
  selectedProducts: IProduct[] = [];
  constructor(public dialogRef: MatDialogRef<SelectProductsComponent>,
              @Inject(MAT_DIALOG_DATA) public selectProducts: SelectProductInput,
              private inkSoftService: InksoftService, public commonService: CommonService) { }

  ngOnInit() {
    this.getProducts();
  }

  fn_FetchLowestPrice(product: IProductDetails) {
    const unitPriceList = product.Sizes;
    const lowestUnitPrice = unitPriceList.sort((a, b) => a.UnitPrice - b.UnitPrice);
    return lowestUnitPrice[0].UnitPrice;
  }

  onClose() {
    this.selectedProducts = this.listProducts.filter(x => x.selected).map(x => {
      var totalCost = this.commonService.fn_CalculateTotalCost(this.fn_FetchLowestPrice(x), x.FinishingPrice, x.PrintingCost, x.ProductSideCount, x.RetailPrice, x.IsEmbroideryType);

      // Get image URL - prioritize Design Huddle
      let imageUrl = '';
      if (x.AzureBlobThumbnailUrl) {
        imageUrl = x.AzureBlobThumbnailUrl;
      } else if (x.PngRelativeUrlWithProduct) {
        imageUrl = this.imgBaseUrl + x.PngRelativeUrlWithProduct;
      } else {
        imageUrl = 'assets/img/placeholder.png';
      }

      return {
        price: totalCost.toString(),
        desc: x.ProductDescription[0].ProductName,
        name: x.Name,
        image: imageUrl,
        DesignId: x.DesignId,
        ProductId:x.ProductId
      };
    });
    this.dialogRef.close(this.selectedProducts);
  }
  getProducts() {
    this.inkSoftService.getStorePublishProductList({
      Skip: 0,
      Take: 100,
      Size: [],
      Brand: [],
      Color: [],
      StoreName: this.selectProducts.storeName,
      Category: '',
      searchBy: ''
    }).subscribe(
      (res: IGetStorePublishProductListInterface) => {
        if (res.StatusCode === 200 && res.Message === 'Success' && res.Data.ResponseData.length > 0) {
          res.Data.ResponseData.forEach((obj: IProductDetails) => {           
            if (!this.listProducts.find(x => x.CustomizedProductId === obj.CustomizedProductId)) {
              obj.selected = this.selectProducts.products.findIndex(x => x.DesignId === obj.DesignId) !== -1;
              this.listProducts.push(obj);
            }
          });
        }
      }
    );
  }

}
